import currency from 'currency.js';

import { getCurrencySymbol } from './currency';

export type CurrencyFormatterOptions = currency.Options & {
  defaultText?: string;
};

export const currencyFormatter = {
  formatUSD(money?: number, options?: CurrencyFormatterOptions) {
    return this.format(money, { symbol: 'USD', pattern: '! #', ...options });
  },
  format(money?: number, options?: CurrencyFormatterOptions) {
    if (money == null || isNaN(money)) {
      return options?.defaultText ?? '--';
    }
    return currency(money).format(options);
  },
  formatCurrency(
    money: number | undefined,
    currency: string,
    options?: CurrencyFormatterOptions,
  ) {
    return this.format(money, {
      symbol: getCurrencySymbol(currency),
      pattern: '! #',
      ...options,
    });
  },
};
